import { render, staticRenderFns } from "./AvatarUploader.vue?vue&type=template&id=12a3c73d&scoped=true&"
import script from "./AvatarUploader.vue?vue&type=script&lang=ts&"
export * from "./AvatarUploader.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarUploader.vue?vue&type=style&index=0&id=12a3c73d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3c73d",
  null
  
)

export default component.exports
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QUploader,QBtn,QAvatar,QImg,QCard,QCardSection,QCardActions,QTooltip});
